export interface SinglePageRoutes {
    orders: string;
    fixtures: string;
}

export const singlePageRoutes: SinglePageRoutes = {
    orders: '/orders',
    fixtures: '/fixtures',
};
